import React from 'react';

// Extend props to include standard HTML div attributes
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

// Forward the ref and spread remaining props (like id, className, etc.)
export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ children, className = '', ...props }, ref) => (
    <div 
      ref={ref} 
      className={`bg-card p-4 rounded-lg border ${className}`}
      {...props} // Spread other props like id, onClick, etc.
    >
      {children}
    </div>
));
Card.displayName = "Card"; // Add display name for DevTools

export const CardHeader = ({ children, className = '' }: CardProps) => (
  <div className={`pb-2 ${className}`}>
    {children}
  </div>
);

export const CardTitle = ({ children, className = '' }: CardProps) => (
  <h3 className={`text-lg font-semibold ${className}`}>
    {children}
  </h3>
);

export const CardContent = ({ children, className = '' }: CardProps) => (
  <div className={`py-2 ${className}`}>
    {children}
  </div>
);

// Add CardFooter if it's needed elsewhere, otherwise can be omitted
export const CardFooter = ({ children, className = '' }: CardProps) => (
  <div className={`pt-2 border-t ${className}`}>
    {children}
  </div>
); 